import React, { useState } from 'react'
import Reveal from './Reveal'
import SectionHead from './SectionHead'
import { usePlaces, usePhotos, useDistance } from '../i18n/hooks'
import { useI18n } from '../i18n/LanguageContext'

function PlaceCard({ place, onOpenArea }) {
  const { t } = useI18n()
  const { photos } = usePhotos()
  const distance = useDistance()
  const [open, setOpen] = useState(false)
  const photo = place.photo ? photos[place.photo] : null
  const dist = distance(place)
  const detailsId = `details-${place.id}`

  return (
    <article className={`place-card cat-${place.category}`}>
      {photo ? (
        <div className="place-media">
          <img src={photo.src} alt={photo.alt} width={photo.width} height={photo.height} loading="lazy" />
        </div>
      ) : (
        <div className="place-media place-media-empty" aria-hidden="true">
          <svg viewBox="0 0 200 80" preserveAspectRatio="none">
            <path d="M0 60 C30 30 60 70 100 45 S170 20 200 40 V80 H0Z" />
            <path d="M0 70 C40 50 70 78 110 60 S170 44 200 58 V80 H0Z" />
          </svg>
        </div>
      )}
      <div className="place-body">
        <div className="place-meta">
          <span className="tag">{t.places.categories[place.category]}</span>
          {dist && <span className="distance" title={t.common.straightLineTitle}>{dist}</span>}
        </div>
        <h3>{place.name}</h3>
        <p>{place.summary}</p>
        {place.details.length > 0 && (
          <button
            type="button"
            className="more"
            aria-expanded={open}
            aria-controls={detailsId}
            onClick={() => setOpen((value) => !value)}
          >
            {open ? t.common.hideDetails : t.common.showDetails}
          </button>
        )}
        <div id={detailsId} className={`expand${open ? ' is-open' : ''}`}>
          <div className="expand-inner">
            <dl className="detail-list">
              {place.details.map(([label, value]) => (
                <div key={label}>
                  <dt>{label}</dt>
                  <dd>{value}</dd>
                </div>
              ))}
            </dl>
            {place.area && (
              <button type="button" className="text-link" onClick={() => onOpenArea(place.area)} tabIndex={open ? 0 : -1}>
                {t.common.readGuide}
              </button>
            )}
          </div>
        </div>
      </div>
    </article>
  )
}

function Places({ onOpenArea }) {
  const { t } = useI18n()
  const { places } = usePlaces()
  const cards = places.filter((place) => place.id !== 'nanovitsa')
  const [filter, setFilter] = useState('all')
  const visible = filter === 'all' ? cards : cards.filter((place) => place.category === filter)

  return (
    <section className="section section-alt" id="places" aria-labelledby="places-title">
      <div className="container">
        <SectionHead id="places-title" kicker={t.places.kicker} title={t.places.title} lead={t.places.lead} />
        <Reveal className="chips" role="group" aria-label={t.common.filterPlacesAria}>
          {t.places.filters.map((chip) => (
            <button
              key={chip.id}
              type="button"
              className={`chip${filter === chip.id ? ' is-active' : ''}`}
              aria-pressed={filter === chip.id}
              onClick={() => setFilter(chip.id)}
            >
              {chip.label}
            </button>
          ))}
        </Reveal>
        <div className="place-grid">
          {visible.map((place) => (
            <PlaceCard key={place.id} place={place} onOpenArea={onOpenArea} />
          ))}
        </div>
      </div>
    </section>
  )
}

export default Places
